// Crisis lines a student in Davao can reach from a mobile phone. Checked on 2026-10-20 against
// SunStar Davao (SPMC-IPBM line, open since 2026-07-01) and the DepEd Lusog-Isip list (NCMH).
// NCMH's 1553 is listed as a Luzon-wide landline, so the mobile numbers lead instead.
// The guidance office should confirm these before launch; a per-school setting can replace this list.

const SPMC = {
  id: 'spmc',
  name: { en: 'SPMC crisis line, Davao', fil: 'SPMC crisis line, Davao' },
  number: '0947 388 5431',
  tel: '09473885431',
  extra: { en: 'Globe 0945 829 2233 · (082) 227 1531', fil: 'Globe 0945 829 2233 · (082) 227 1531' },
  hours: { en: '8 AM–10 PM daily', fil: '8 AM–10 PM araw-araw' },
  opensAt: 8,
  closesAt: 22,
};

const NCMH = {
  id: 'ncmh',
  name: { en: 'NCMH crisis line', fil: 'NCMH crisis line' },
  number: '0917 899 8727',
  tel: '09178998727',
  extra: { en: 'Smart 0908 639 2672', fil: 'Smart 0908 639 2672' },
  hours: { en: '24/7', fil: '24/7' },
};

const EMERGENCY = {
  id: '911',
  name: { en: 'Emergency', fil: 'Emergency' },
  number: '911',
  tel: '911',
  extra: { en: 'Davao Central 911', fil: 'Davao Central 911' },
  hours: { en: '24/7', fil: '24/7' },
};

export const isOpen = (line, now = new Date()) => {
  if (line.opensAt == null) return true;
  const hour = now.getHours();
  return hour >= line.opensAt && hour < line.closesAt;
};

/** The lines in the order to show them: the Davao line first while it is open, the 24/7 NCMH line first otherwise. */
export const orderedCrisisLines = (now = new Date()) =>
  isOpen(SPMC, now) ? [SPMC, NCMH, EMERGENCY] : [NCMH, SPMC, EMERGENCY];
